export default __webpack_public_path__ + "static/media/Login-documentation.f16525c9.md";